// An instance's off-box browser switches, set by admins (browser_tenant_settings).
// A null budget means the broker's default.
export type BrowserSettings = {
  readonly recordingEnabled: boolean;
  readonly dailyMinutes: number | null;
  readonly monthlyMinutes: number | null;
};

export type BrowserSettingsView = BrowserSettings & {
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
};

export const DAILY_MINUTES_MAX = 24 * 60;
export const MONTHLY_MINUTES_MAX = 31 * 24 * 60;

// "" is the broker's default; otherwise a whole number of minutes up to max, or "invalid".
export const parseBudgetMinutes = (draft: string, max: number): number | null | "invalid" => {
  const trimmed = draft.trim();
  if (trimmed === "") return null;
  if (!/^\d+$/.test(trimmed)) return "invalid";
  const minutes = Number(trimmed);
  return minutes <= max ? minutes : "invalid";
};

export const budgetDraft = (minutes: number | null): string => (minutes === null ? "" : String(minutes));
